module.exports = __webpack_public_path__ + "files/099be811f82c7b6976d336aab50a7d24.png";